import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from './Navbar';
import { ClompApi } from '../api/ClompApi';
import './ClompyClicker.css';

const api = new ClompApi();

// How often clicks are sent to the backend while the game is being played
const SYNC_MS = 2000;

// A gold coin, drawn like the coins in old platform games: a raised rim, a slot down the middle and a glint
export function CoinIcon() {
    return (
        <svg className="clompy-coin" viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="11" fill="#b07e1a" />
            <circle cx="12" cy="12" r="9.4" fill="#ffd56a" />
            <circle cx="12" cy="12" r="7.2" fill="#f3bb3c" />
            <rect x="10.2" y="6.6" width="3.6" height="10.8" rx="1.8" fill="#b07e1a" />
            <rect x="10.9" y="7.6" width="1.3" height="8.8" rx="0.65" fill="#ffe9a8" />
            <path d="M5.6 9.4a7 7 0 0 1 3.3-3.6" fill="none" stroke="#fff4c8" strokeWidth="1.3" strokeLinecap="round" />
        </svg>
    );
}

export class ClompyClickerGame extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showHelp: false,
            showShare: false,
            // Coins saved on the backend for a logged-in player; coins shown are these plus the clicks not yet sent
            saved: 0,
            pending: 0,
            pressed: false,
            // Logged-in players' coins are saved and count towards the leaderboard; anyone else plays for fun
            loggedIn: localStorage.getItem('token') !== null,
        }
        // clicks made while a save is under way
        this.sending = 0;
    }

    componentDidMount() {
        if (this.state.loggedIn) {
            api.games.getClickerCoins().then((mine) => {
                this.setState({ saved: mine.coins });
            }).catch((err) => this.syncFailed(err));
        }
        this.timer = setInterval(this.sync, SYNC_MS);
        document.addEventListener('visibilitychange', this.sync);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.sync);
        this.unmounted = true;
        this.sync();
    }

    // Send the clicks made since the last save
    sync = () => {
        let clicks = this.state.pending;
        if (!this.state.loggedIn || clicks === 0 || this.sending > 0) {
            return;
        }
        this.sending = clicks;
        if (!this.unmounted) {
            this.setState({ pending: 0 });
        }
        api.games.addClickerClicks(clicks).then((result) => {
            this.sending = 0;
            if (!this.unmounted) {
                this.setState({ saved: result.coins });
            }
        }).catch((err) => {
            // keep the clicks to try again
            let unsent = this.sending;
            this.sending = 0;
            if (!this.unmounted) {
                this.setState((s) => ({ pending: s.pending + unsent }));
                this.syncFailed(err);
            }
        });
    }

    syncFailed(err) {
        if (err.response && err.response.status === 401) {
            // the login ran out: carry on as a guest with the coins on screen
            this.setState((s) => ({ loggedIn: false, pending: s.saved + s.pending, saved: 0 }));
        } else {
            console.log('Error saving coins: ', err);
        }
    }

    getShareURL() {
        return window.location.origin + window.location.pathname;
    }

    toggleHelp() {
        this.setState({
            showHelp: !this.state.showHelp
        });
    }

    toggleShare() {
        this.setState({
            showShare: !this.state.showShare
        });
    }

    clompyClicked = (e) => {
        // only the main button of a mouse; touches and pens always count
        if (e.pointerType === 'mouse' && e.button !== 0) {
            return;
        }
        this.setState((s) => ({ pending: s.pending + 1, pressed: true }));
    }

    clompyReleased = () => {
        if (this.state.pressed) {
            this.setState({ pressed: false });
        }
    }

    // Space and Enter click the mug too
    clompyKeyDown = (e) => {
        if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) {
            e.preventDefault();
            this.setState((s) => ({ pending: s.pending + 1, pressed: true }));
        }
    }

    render() {
        // while a save is under way its clicks are in neither count
        let coins = this.state.saved + this.state.pending + this.sending;

        let helpPopup = (
            <div className='wordle-popup' onClick={this.toggleHelp.bind(this)}>
                <div className='wordle-popup-content'>
                    <h2>How to play</h2>
                    <p>
                        The goal of the game is to collect Coins.
                        <br />
                        Coins can be collected by clicking the mug.
                        <br />
                        Coins can also be spent to upgrade certain attributes.
                        <br />
                        Compete against others to gather the most Coins.
                    </p>
                </div>
            </div>
        );

        let sharePopup = (
            <div className='wordle-popup' onClick={this.toggleShare.bind(this)}>
                <div className='wordle-popup-content'>
                    <h2>Share this game</h2>
                    <div className='button-row'>
                        <a className='wordle-button' href={`https://twitter.com/intent/tweet?text=I%20just%20played%20a%20word%20puzzle%20with%20Wordle%20on%20clomp.io!%20Check%20it%20out%20at%20${encodeURIComponent(this.getShareURL())}`} target='_blank' rel='noopener noreferrer'
                            style={
                                {
                                    backgroundColor: '#1DA1F2',
                                    color: 'white'
                                }
                            }>
                            {/* twitter icon */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                <path fill="#FFFFFF" d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"></path>

                            </svg>
                        </a>
                        <div className='wordle-button' onClick={ () => {
                                navigator.clipboard.writeText(this.getShareURL());
                            }}>
                            Copy link &nbsp;
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                <path fill="var(--color-tone-1)" d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        );
        return (
            <>
                <Navbar />
                <div className="wordle">
                    <div className="wordle-header">
                        <h1>Clompy Clicker</h1>
                        <div onClick={this.toggleHelp.bind(this)}>
                            <svg height="24" viewBox="0 0 24 24" width="24">
                                <path fill="var(--color-tone-1)" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"></path>
                            </svg>
                        </div>
                    </div>

                    <div className="clompyclicker">
                        <div className="game-area">
                            <div className="clompy-coins" role="status" aria-label={`${coins.toLocaleString()} coins`}>
                                <CoinIcon />
                                <span>{coins.toLocaleString()}</span>
                            </div>
                            {/* the mug sits in a box of fixed size and shrinks inside it when pressed, so nothing around it moves */}
                            <div className="clompy-mug">
                                <img className={this.state.pressed ? 'is-pressed' : ''} src="/img/clompyclicker/mug.png" alt="Clompy the mug: click to collect coins"
                                    role="button" tabIndex="0" draggable="false"
                                    onPointerDown={this.clompyClicked} onPointerUp={this.clompyReleased} onPointerLeave={this.clompyReleased} onPointerCancel={this.clompyReleased}
                                    onKeyDown={this.clompyKeyDown} onKeyUp={this.clompyReleased} onBlur={this.clompyReleased} />
                            </div>
                            <div className="clompy-buttons">
                                <button type="button" className="clompy-button" disabled title="Coming soon">Upgrades</button>
                                <button type="button" className="clompy-button" disabled title="Coming soon">Stats</button>
                                <Link className="clompy-button clompy-button-primary" to="/leaderboard?game=clompyclicker">Leaderboard</Link>
                            </div>
                            {this.state.loggedIn ? null :
                                <p className="clompy-note"><Link to="/login?next=/clompyclicker">Log in</Link> to save your coins and join the leaderboard.</p>
                            }
                        </div>
                    </div>

                    {this.state.showHelp ? helpPopup : null}
                    {this.state.showShare ? sharePopup : null}
                </div>
            </>
        )
    }

}
